module.exports = __webpack_public_path__ + "img/lokesh-image.9e04933b.jpeg";